  // The labels will now only show on the first chart of each new row
  const renderFunnelold = (brand, index,settings,getLogoComponent,labelWidth,maxBarWidth,barHeight,logoMap,stageGap,barAreaWidth) => {
    // We check if the index is a multiple of the current 'columns' value
    const showLabels = index % settings.columns === 0;
    const funnelDataWithConversion = brand.funnelData.map((stage, idx) => {
      const prevPercentage = idx === 0 ? 100 : brand.funnelData[idx - 1].percentage;
      const conversion = prevPercentage > 0 ? ((stage.percentage / prevPercentage) * 100).toFixed(1) : 0;
      return { ...stage, conversion };
    });

    return (
      <div style={{ minWidth: 300, margin: '0 10px' }}>
        <div 
  style={{ 
    height: '60px', // Set a fixed height for the logo container
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    textAlign: 'center',
    marginBottom: 20 
  }}
>
  {logoMap[brand.logo]}
</div>
<h3 style={{ color: brand.color, margin: 0,textAlign: 'center', }}>{brand.name}</h3>
        <div style={{ display: 'flex', gap: 10 }}>
          <div
            style={{
              width: showLabels? labelWidth: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: stageGap,
              justifyContent: 'flex-start'
            }}
          >
            {showLabels && funnelDataWithConversion.map((stage, idx) => (
              <div
                key={idx}
                style={{
                  height: barHeight,
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '12px',
                  lineHeight: 1.2,
                  paddingLeft: 5,
                  textAlign: 'left'
                }}
              >
                {stage.label}
              </div>
            ))}
            {!showLabels && funnelDataWithConversion.map((_, idx) => (
              <div
                key={idx}
                style={{
                  height: barHeight,
                  display: 'flex',
                  alignItems: 'center'
                }}
              />
            ))}
          </div>
          <div
            style={{
              width: barAreaWidth,
              display: 'flex',
              flexDirection: 'column',
              gap: stageGap,
              alignItems: 'center',
              position: 'relative'
            }}
          >
            {funnelDataWithConversion.map((stage, idx) => (
              <div
                key={idx}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative'
                }}
              >
                <div
                  style={{
                    width: `${(stage.percentage / 100) * maxBarWidth}px`,
                    height: barHeight,
                    backgroundColor: brand.color,
                    borderRadius: `${barHeight / 2}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'black',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    minWidth: '20px',
                    opacity: idx === 0 ? 1 : 0.7 - (idx * 0.05)
                  }}
                >
                  {typeof stage.percentage === 'number' ? stage.percentage.toFixed(1) : stage.percentage}%
                </div>
                {idx > 0 && (
                  <div style={{ position: 'absolute', left: '90%', top: '10%', transform: 'translateY(-50%)' }}>
                    <span style={{ fontSize: '10px', color: '#666' }}>&#8617; {stage.conversion}%</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };
export default renderFunnelold;